export default __webpack_public_path__ + "static/media/logo7.edbc6228.png";